import React from 'react';
import './css/App.css';
import Routes from './routes';

export default () => <Routes />;
